import React from 'react';
import ReactDOM from 'react-dom';
import Loadable from 'react-loadable';

export const PageBottomBrand = Loadable({
    loader: () => import(/* webpackChunkName: "PageBottomBrand" */ './pageBottomBrand'),
    loading: () => <div />,
});
